"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoPointToJSON = exports.GeoPointFromJSONTyped = exports.GeoPointFromJSON = void 0;
var _1 = require("./");
function GeoPointFromJSON(json) {
    return GeoPointFromJSONTyped(json, false);
}
exports.GeoPointFromJSON = GeoPointFromJSON;
function GeoPointFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': (0, _1.GeoJsonTypeFromJSON)(json['type']),
        'coordinates': json['coordinates'],
    };
}
exports.GeoPointFromJSONTyped = GeoPointFromJSONTyped;
function GeoPointToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': (0, _1.GeoJsonTypeToJSON)(value.type),
        'coordinates': value.coordinates,
    };
}
exports.GeoPointToJSON = GeoPointToJSON;
